import { VideoContext } from './VideoContext'

const Provider = ({ children }) => {
  return <VideoContext>{children}</VideoContext>
}

export default Provider
